// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scoreboard_wrapper__1EW5Q","scoreLabel":"Scoreboard_scoreLabel__sPkQJ"};